
import React, { useEffect, useState } from 'react'
import Modal from 'components/modal'
import 'less/change-password-profile-modal.less'
import Field from 'components/controls/field'
import { validatePasswordWithError, validate } from 'shared/helpers/validate'


const ChangePasswordProfileModal = props => {
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")
  const [validateCurrentPassword, setValidateCurrentPassword] = useState(validate(validatePasswordWithError, ''),)
  const [validateNewPassword, setValidateNewPassword] = useState(validate(validatePasswordWithError, ''))
  const [validateConfirmNewPassword, setValidateConfirmNewPassword] = useState("")
  const [passwordMatches, setPasswordMatches] = useState(props.user.passwordMatches)

  const updateCurrentPassword = (value) => {
    const newCurrentPassword = validate(validatePasswordWithError, value)
    setCurrentPassword(newCurrentPassword.value)
    setValidateCurrentPassword(newCurrentPassword)
  }

  const updateNewPassword = (value) => {
    const password = validate(validatePasswordWithError, value)
    setNewPassword(password.value)
    setValidateNewPassword(password)
    setValidateConfirmNewPassword(value === confirmNewPassword && value.length !==0 )
  }

  const confirmPassword = (value) => {
    setConfirmNewPassword(value)
    setValidateConfirmNewPassword(value === newPassword && value.length !==0 )
  }

  useEffect(() => {
    setValidateConfirmNewPassword(newPassword === confirmNewPassword && newPassword.length !== 0 && confirmNewPassword.length !== 0)
  },[confirmNewPassword, newPassword])

  const returnError = () => {
    if(confirmNewPassword.length === 0 || validateConfirmNewPassword) {
      return []
    } else return ['Please re-enter your new password']
  }

  const setCurrentPasswordErrors = () => {
    if (!validateCurrentPassword.isValid && validateCurrentPassword.value.length > 0) {
      return [validateCurrentPassword.error]
    } else if (passwordMatches === false && validateCurrentPassword.value.length > 0) {
      return ["The current password you provided does not match the one we have on records."]
    }
  }
  useEffect(() => {
    setPasswordMatches(true)
  }, [currentPassword])

  useEffect(() => {
    setPasswordMatches(props.user.passwordMatches)
  }, [props.user.passwordMatches])

  return (
    <Modal
      title={"CHANGE PASSWORD"}
      isOpen={props.isOpen}
      className="change-password-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Save"
      onCancel={props.onClose}
      onSubmit={() => props.matchCurrentPassword({currentPassword:currentPassword, password: confirmNewPassword })}
      isSubmitting={props.isFetching}
      enableSubmit={validateConfirmNewPassword && validateNewPassword.isValid && validateCurrentPassword.isValid}
    >
      <div className="change-password-modal-body">
        <div className="change-password-modal-text">
          <p> Update your Password. </p>
          <div className="update-password-form">
            <div className={`current-password ${passwordMatches === false ? 'password-dont-match' : ''}`}>
              <Field
                label="Current Password"
                type="password"
                onChange={e => updateCurrentPassword(e.target.value)}
                value={currentPassword}
                errors={setCurrentPasswordErrors()}
                valid={validateCurrentPassword.isValid && passwordMatches === true && []}
              />
            </div>
            <Field
              label="New Password"
              type="password"
              onChange={e => updateNewPassword(e.target.value)}
              value={newPassword}
              errors={!validateNewPassword.isValid && validateNewPassword.value.length > 0 && [validateNewPassword.error]}
              valid={validateNewPassword.isValid && []}
            />
            <div className='confirm-new-password'>
              <Field
                label="Confirm New Password"
                type="password"
                onChange={e => confirmPassword(e.target.value)}
                value={confirmNewPassword}
                errors={returnError()}
                valid={validateConfirmNewPassword && []}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal >
  )
}

export default ChangePasswordProfileModal
